import React from 'react';
import { useMaskito } from '@maskito/react';
import options from './Mask';
import './Input.scss';
import './Input-media.scss';
import ErrorText from '../ErrorText/ErrorText';

export interface Props {
  placeholder?: string;
  name?: string;
  value?: string;
  label?: string;
  type?: string;
  onChange?: any;
  onClick?: any;
  focus?: boolean;
  error?: string | null;
  marginTop?: number;
}

const InputPhoneStandalone = ({
  type = 'text',
  name,
  placeholder = '',
  value,
  label,
  onChange,
  onClick,
  error,
  marginTop = 32,
}: Props) => {
  const maskedInputRef = useMaskito({ options });

  const focus = false;

  return (
    <div className="input">
      {label ? (
        <p className="input__label" style={{ marginTop }}>
          {label}
        </p>
      ) : null}
      <input
        ref={maskedInputRef}
        type={type}
        name={name}
        className={`input__field${error ? ' input__field_error' : ''}`}
        placeholder={placeholder}
        value={value}
        onInput={onChange}
        onClick={onClick}
        autoFocus={focus}
      />
      {error ? <span className="input__error"></span> : null}
      {error ? ErrorText(error) : null}
    </div>
  );
};

export default InputPhoneStandalone;
